/**
 * Resolve a campaign's game keys into full IGameSettings objects.
 *
 * Reads from the canonical `supportedGames` catalog (one entry per gameKey)
 * instead of `sections.flatMap(s => s.games)`. Like this, we avoid the risk of clones 
 *  and leak structurally impossible
 * 
 * `topGameKeys` carries the TOP-section membership so the TOP badge stays
 * correct (parseGameSettings derives `topGame` from the passed flag, not from
 * the raw game data).
 */

import { parseGameSettings } from '../../../shared/utils/gameParsingUtils';
import type { ApiGameSettings } from '../../../types/api/api.types';
import type IGameSettings from '../../../types/models/IGameSettings';

export const resolveCampaignGames = (
  gameKeys: string[],
  supportedGames: { [gameKey: string]: ApiGameSettings },
  topGameKeys: Set<string>,
): IGameSettings[] =>
  gameKeys
    .map((gameKey, index) =>
      parseGameSettings({
        mutatedGame: { gameKey, order: index, imageLobby: 'vertical', imageSection: 'vertical' },
        gameData: supportedGames[gameKey],
        isTopGame: topGameKeys.has(gameKey),
      }),
    )
    .filter((game): game is IGameSettings => game !== null);
